var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgAdminsLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-admins-link_svg__cls-1,.kpmg-admins-link_svg__cls-4{fill:#fff;stroke:#fff;stroke-width:.5px;stroke-linecap:round;stroke-linejoin:round}.kpmg-admins-link_svg__cls-4{fill:none;stroke:#30acec;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-admins-link_svg__ICN_Admin_KPMG_Active",
    "data-name": "ICN_Admin KPMG_Active",
    transform: "translate(-119 -150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-admins-link_svg__Group_1273",
    "data-name": "Group 1273",
    transform: "translate(122.833 154.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-admins-link_svg__Group_1242",
    "data-name": "Group 1242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-admins-link_svg__Path_891",
    d: "M-68.326-171.192h.121a3.478 3.478 0 002.658-1.15c1.451-1.636 1.21-4.44 1.183-4.708a3.846 3.846 0 00-1.828-3.419 4.191 4.191 0 00-2.029-.531h-.064a4.2 4.2 0 00-2.028.516 3.848 3.848 0 00-1.851 3.434c-.026.268-.268 3.072 1.184 4.708a3.464 3.464 0 002.654 1.15zm-2.831-5.763v-.03c.124-2.7 2.043-2.993 2.865-2.993h.045c1.018.023 2.748.437 2.865 2.993a.072.072 0 000 .03c0 .026.268 2.59-.931 3.939a2.47 2.47 0 01-1.941.807h-.038a2.463 2.463 0 01-1.937-.807c-1.195-1.342-.938-3.916-.935-3.939zm0 0",
    className: "kpmg-admins-link_svg__cls-1",
    "data-name": "Path 891",
    transform: "translate(76.002 181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-admins-link_svg__Path_892",
    d: "M-137.519 31.084v-.105c-.022-.746-.072-2.492-1.707-3.049l-.038-.011a10.879 10.879 0 01-3.129-1.425.508.508 0 00-.709.124.508.508 0 00.124.709 11.751 11.751 0 003.442 1.572c.878.313.976 1.251 1 2.111a.74.74 0 000 .094 6.859 6.859 0 01-.079 1.165c-.472.83-3.208 2.458-6.849 2.458-3.626 0-6.369-1.5-6.445-2.462a6.474 6.474 0 01-.079-1.165v-.094c.027-.859.124-1.8 1-2.111a11.841 11.841 0 003.441-1.572.508.508 0 00.124-.709.508.508 0 00-.709-.124 10.757 10.757 0 01-3.129 1.425l-.038.011c-1.636.562-1.685 2.307-1.707 3.049a.774.774 0 010 .094v.011a5.778 5.778 0 00.192 1.707.483.483 0 00.2.237 10.4 10.4 0 007.154 2.715 12.115 12.115 0 007.561-2.715c.087-.056.339-.139.377-.237a4.982 4.982 0 000-1.7zm0 0",
    className: "kpmg-admins-link_svg__cls-1",
    "data-name": "Path 892",
    transform: "translate(153 -15.969)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-admins-link_svg__Path_896",
    "data-name": "Path 896",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.421S5.852 0 11.6 0s11.382 3.421 11.382 3.421v18.222s-3.6 7.685-11.385 9.827C3.373 29.206 0 21.643 0 21.643z",
    transform: "translate(119 150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.598 1.6C7.54 1.6 3.315 3.51 1.6 4.38v16.89c.299.577 1.079 1.96 2.396 3.472 2.154 2.475 4.71 4.176 7.6 5.06 2.72-.842 5.185-2.53 7.336-5.019a20.142 20.142 0 002.45-3.526V4.363C19.728 3.494 15.655 1.6 11.598 1.6m0-1.6c5.745 0 11.384 3.42 11.384 3.42v18.223s-3.601 7.685-11.384 9.827C3.373 29.206 0 21.643 0 21.643V3.421S5.852 0 11.598 0z",
    transform: "translate(119 150)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-admins-link_svg__Path_897",
    d: "M-24094.086-16797.338l3.246 1.549v5.158",
    className: "kpmg-admins-link_svg__cls-4",
    "data-name": "Path 897",
    transform: "translate(24229.172 16952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-admins-link_svg__Path_898",
    d: "M-24090.84-16797.338l-3.246 1.549v5.158",
    className: "kpmg-admins-link_svg__cls-4",
    "data-name": "Path 898",
    transform: "translate(24216.807 16952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-admins-link_svg__Path_899",
    d: "M-24102.723-16775.736l3.58 1.824 3.723-1.824",
    className: "kpmg-admins-link_svg__cls-4",
    "data-name": "Path 899",
    transform: "translate(24229.496 16951.469)"
  }))));
}

export default SvgKpmgAdminsLink;